
export const getClosestSunday = () => {

    const today = new Date();
    today.setDate(today.getDate());
    let result = today;
    while (result.getDay() !== 0) {
        result.setDate(result.getDate()-1);
    }
    return result;
}

export const getDateOptions = (): Date[][] => {
    const options: Date[][] = [];
    const lastSunday = getClosestSunday();
    let current = lastSunday;
    let numWeeks=0;
    while (numWeeks < 8) {
        const start = new Date(current);
        start.setDate(current.getDate() - 6);
        const end = new Date(current);
        options.push([start, end]);
        current = new Date(start);
        current.setDate(start.getDate() - 1);
        numWeeks++;
    }

    return options;
}

export const getSqlDateFormat = (date: Date): string => date.toISOString().split('T')[0];